<template v-if="skin">
  <v-dialog v-model="spinner.active" persistent width="300">
    <v-card light>
      <v-card-text>
        {{ spinner.message }}
        <v-progress-linear indeterminate color="primary" class="mb-0"></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: "LoadingSpinner",
  computed: {
    ...mapState({
      spinner: state => state.spinner,
      skin: state => state.settings.skin
    })
  }
};
</script>